export enum CustomerType {
  Students = 'students',
  Employees = 'employees',
}
